(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* After a submission the page reloads; bring the result into focus for screen readers. */
    var status = document.getElementById('ContactForm-status');
    if (status) {
      status.focus({ preventScroll: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('site-header')) {
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        this.onScroll = this.onScroll.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('click', this.onDocumentClick);
        this.addEventListener('keyup', this.onKeyUp);
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('click', this.onDocumentClick);
      }

      onScroll() {
        this.classList.toggle('is-scrolled', window.scrollY > 8);
      }

      onDocumentClick(event) {
        this.querySelectorAll('details[open]').forEach(function (details) {
          if (!details.contains(event.target)) details.removeAttribute('open');
        });
      }

      onKeyUp(event) {
        if (event.key !== 'Escape') return;
        var openDetails = this.querySelector('details[open]');
        if (!openDetails) return;
        openDetails.removeAttribute('open');
        openDetails.querySelector('summary').focus();
      }
    }

    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.hero__video').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
      video.setAttribute('controls', '');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    /* A wrong password reloads the page with errors: reopen the dialog and focus the field. */
    var dialog = document.querySelector('[data-password-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (!dialog.querySelector('[data-password-error]')) return;

    dialog.showModal();
    var input = dialog.querySelector('input[type="password"]');
    if (input) input.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symbol-experience"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* ------------------------------------------------ act reveals (II, III) */
    function activateAll(scope) {
      (scope || document).querySelectorAll('[data-symbol-act]').forEach(function (act) {
        act.classList.add('is-active');
      });
    }

    function initActs(scope) {
      if (reduceQuery.matches || !('IntersectionObserver' in window)) return activateAll(scope);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-active');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      (scope || document).querySelectorAll('[data-symbol-act]:not(.is-active)').forEach(function (act) {
        observer.observe(act);
      });
    }

    /* ------------------------------------------- Flower of Life construction */
    function Construction(root) {
      this.root = root;
      this.replay = root.parentElement.querySelector('[data-construction-replay]');
      this.circles = Array.prototype.slice.call(root.querySelectorAll('.flower__circle'));
      this.points = Array.prototype.slice.call(root.querySelectorAll('.flower__point'));
      this.duration = Math.max(150, parseInt(root.dataset.duration, 10) || 450);
      this.pause = Math.max(0, parseInt(root.dataset.pause, 10) || 0);
      this.withLogo = root.dataset.logo === 'true';
      this.run = 0;
      this.safety = null;
      this.logoTimer = null;

      var self = this;
      if (this.replay) {
        this.replay.addEventListener('click', function () {
          self.start();
        });
      }
    }

    Construction.prototype.canAnimate = function () {
      return (
        this.root.dataset.animate === 'true' &&
        document.documentElement.dataset.animation !== 'none' &&
        !reduceQuery.matches &&
        typeof this.root.animate === 'function'
      );
    };

    Construction.prototype.clear = function () {
      window.clearTimeout(this.safety);
      window.clearTimeout(this.logoTimer);
      this.root.getAnimations({ subtree: true }).forEach(function (animation) {
        animation.cancel();
      });
    };

    /* Always the final state: complete figure, then (optionally) the logo. */
    Construction.prototype.complete = function (run) {
      if (run !== undefined && run !== this.run) return;
      var self = this;
      this.clear();
      this.root.dataset.state = 'complete';
      if (this.replay) this.replay.hidden = !this.canAnimate();
      if (this.withLogo) {
        this.logoTimer = window.setTimeout(function () {
          self.root.classList.add('is-logo-visible');
        }, run === undefined ? 0 : 450);
      }
    };

    Construction.prototype.start = function () {
      if (!this.canAnimate()) return this.complete();

      var self = this;
      var run = ++this.run;
      var duration = this.duration;
      var pause = this.pause;
      var time = 350;
      var last = null;

      this.clear();
      this.root.classList.remove('is-logo-visible');
      this.root.dataset.state = 'drawing';
      if (this.replay) this.replay.hidden = true;

      this.circles.forEach(function (circle) {
        var step = parseInt(circle.dataset.step, 10);
        var point = self.points[step];
        var length = parseFloat(circle.style.getPropertyValue('--len'));
        var isBound = circle.classList.contains('flower__circle--bound');
        var circleDuration = isBound ? Math.round(duration * 1.8) : duration;

        if (point) {
          point.animate([{ opacity: 0 }, { opacity: 0.6 }], {
            duration: 260,
            delay: time,
            fill: 'forwards',
            easing: 'ease-out'
          });
        }

        last = circle.animate([{ strokeDashoffset: length }, { strokeDashoffset: 0 }], {
          duration: circleDuration,
          delay: time + (point ? 150 : 0),
          fill: 'forwards',
          easing: 'cubic-bezier(0.45, 0, 0.25, 1)'
        });

        /* The next circle starts only after this one has fully closed. */
        time += (point ? 150 : 0) + circleDuration + pause;
      });

      if (last) {
        last.finished.then(
          function () {
            self.complete(run);
          },
          function () {}
        );
      }

      /* Safety net: whatever happens (throttled tab, interrupted frames), never stay half drawn. */
      this.safety = window.setTimeout(function () {
        self.complete(run);
      }, time + 1500);
    };

    Construction.prototype.init = function () {
      var self = this;

      if (!this.canAnimate() || !('IntersectionObserver' in window)) {
        this.complete();
        return;
      }

      this.root.dataset.state = 'pending';

      /* Start once, when the figure is clearly in view; scrolling away never interrupts it. */
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            self.start();
          });
        },
        { threshold: 0.45 }
      );
      observer.observe(this.root);
    };

    function initConstructions(scope) {
      (scope || document).querySelectorAll('[data-construction]').forEach(function (root) {
        if (root._construction) return;
        root._construction = new Construction(root);
        root._construction.init();
      });
    }

    reduceQuery.addEventListener('change', function () {
      document.querySelectorAll('[data-construction]').forEach(function (root) {
        if (root._construction) root._construction.complete();
      });
    });

    /* Restored from the back/forward cache: show the finished figure. */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      document.querySelectorAll('[data-construction]').forEach(function (root) {
        if (root._construction && root.dataset.state !== 'complete') root._construction.complete();
      });
    });

    function init(scope) {
      initActs(scope);
      initConstructions(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      activateAll(event.target);
      initConstructions(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
